import src from "./chat-circle-text.svg"

const width = 20
const height = 20
export default { src, width, height }
